import React, { Component } from "react";
import "./styles.css";
import Icon from "../../prefabs/icon/view";

class InputToggle extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onClickBtn = this.onClickBtn.bind(this);
  }



  // ===============================================================================================
  onClickBtn(e) {
    e.preventDefault();
    this.props.handleChange(!this.props.checked);
  }



  // ===============================================================================================
  render() {
    return (
      <div className={"input-toggle" +
        ((this.props.disabled) ? " input-toggle--disabled" : "") +
        ((this.props.class) ? (" " + this.props.class) : "")}>

        <div className="input-toggle__left" dangerouslySetInnerHTML={{ __html: this.props.label }}>
          {/* {this.props.label} */}
        </div>

        <div className="input-toggle__right">
          <button className={"input-toggle__btn" +
            ((this.props.checked) ? " input-toggle__btn--checked" : "")}
            tabIndex="-1"
            onClick={this.onClickBtn}
            disabled={this.props.disabled}>
            <Icon type={(this.props.checked) ? "checkmark-yb" : "checkbox-b"}/>
          </button>
        </div>

      </div>
    );
  }

}



export default InputToggle
